<template>
  <helmi-group-dashboard-card
    :initializing="loadingCharts"
    class="helmi-group-dashboard-offices"
    title="Vuoden kokonaistuotto toimistoittain"
    subtitle="(Brutto)"
    min-height="560px"
    use-theme
    fullscreen
  >
    <v-data-iterator
      :footer-props="footerProps"
      :options.sync="listOptions"
      :items="echartsData"
      :dark="theme === 'dark'"
      :class="{ 'dark-theme': theme === 'dark' }"
    >
      <template #default="props">
        <v-list two-line :dark="theme === 'dark'">
          <v-list-item
            v-for="(office, index) in props.items"
            :key="office.id"
            :disabled="processingData"
            :style="`animation-delay: ${index * 150}ms;`"
          >
            <span class="list-ornament" :class="colors[index % colors.length]"/>
            <v-list-item-content>
              <v-list-item-title>
                {{ office.name }}, {{ office.city }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ office.address }}, {{ office.city }}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <v-icon color="pink" small>
                  phone
                </v-icon>
                {{ office.phone }}
                <v-icon
                  color="pink"
                  small
                  class="ml-2"
                >
                  mail
                </v-icon>
                {{ office.email }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-list-item-action-text>
                <v-chip small>
                  {{ office.value | currency }}
                </v-chip>
              </v-list-item-action-text>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </template>
    </v-data-iterator>
  </helmi-group-dashboard-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'GroupDashboardOffices',

  components: {
    'helmi-group-dashboard-card': () => import('@/components/groupDashboard/GroupDashboardCard'),
  },

  props: {
    colors: {
      type: Array,
      default: new Array(5),
    },
  },

  data: () => ({
    echartsData: [],
    listOptions: {
      itemsPerPage: 5,
      page: 1,
    },
    footerProps: {
      itemsPerPageOptions: [5, 10, 15, -1],
    },
    processingData: false,
  }),

  computed: {
    ...mapState({
      selectedGroupCompanies: 'selectedGroupCompanies',
      chartYear: 'chartYear',
      monthlyProfit: 'monthlyProfit',
      loadingCharts: 'loadingCharts',
      theme: 'theme',
    }),
  },

  watch: {
    monthlyProfit: {
      async handler() {
        this.fillCharts();
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async fillCharts() {
      this.echartsData = this.monthlyProfit.map(result => ({
        name: result.name,
        city: result.city,
        address: result.address,
        phone: result.phone,
        email: result.email,
        value: +((result.data.map(item => item.profit)
          .reduce((a, b) => a + b, 0)).toFixed(2)),
      })).sort((a, b) => ((a.value > b.value) ? 1 : -1)).reverse();
    },
  },
};
</script>

<style lang="scss">
.theme--dark.v-list {
  background: rgba(100, 100, 100, 0.25);
}

.dark-theme .v-data-footer__select, .dark-theme .v-data-footer__pagination {
  color: #FFF !important;
}

.v-data-iterator.dark-theme {
    color: #FFF !important;
}

.v-data-iterator > div:not(.v-list) {
  padding-left: 8px;
}

.is-fullscreen .v-list {
  height: 100vh;
  overflow-y: scroll;
}
</style>
